import { companyStatus } from "../../const/const";

export function convertCompanyStatus(status: keyof typeof companyStatus) {
  if (status in companyStatus) {
    return companyStatus[status];
  }

  return "-";
}
